// Generated from src/img/svg/star.svg

export const Star = (props) => {
  return (
    <svg height="20.5" viewBox="0 0 21.579 20.5" width="21.579" {...props}>
      <path d="m10.789 16.476 6.668 4.024-1.769-7.585 5.891-5.1-7.758-.658L10.789 0 7.757 7.153 0 7.812l5.891 5.1L4.122 20.5Z" />
    </svg>
  );
};
